import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

export default function useBulkCatalogue() {
  
  const { api, anlookApi, userID, getCatalogIdUSCodeCached } =
    useContext(GlobalContext);

const resolveBulkCatalogId = async ({ force = false } = {}) => {
  try {
    const usCode = String(userID || "").trim();

    if (!usCode) return "";

    // Shared GlobalContext session cache
    const res = await getCatalogIdUSCodeCached(usCode, { force });

    if (String(res?.data?.responseCode ?? "") !== "00") {
      toast.error(
        res?.data?.responseMessage || "Failed to fetch catalogue mapping ID",
      );
      return "";
    }

    const response = res?.data?.response;

    const mappingId = Array.isArray(response)
      ? response?.[0]?.mapping_id
      : response?.mapping_id;

    const catalogId = String(mappingId ?? "").trim();

    if (!catalogId) {
      toast.error("Catalogue mapping ID not found");
      return "";
    }

    return catalogId;
  } catch (error) {
    console.error("getCatalogIdUSCode error:", error?.response?.data || error);

    toast.error(
      error?.response?.data?.responseMessage ||
        error?.response?.data?.message ||
        error?.message ||
        "Error fetching catalogue mapping ID",
    );

    return "";
  }
};


  const [restaurantSaving, setRestaurantSaving] = useState(false);
  const [restaurantsLoading, setRestaurantsLoading] = useState(false);
  const [restaurantDeletingId, setRestaurantDeletingId] = useState("");
  const [catalogueSaving, setCatalogueSaving] = useState(false);
  const [cataloguesLoading, setCataloguesLoading] = useState(false);
  const [catalogueDeletingId, setCatalogueDeletingId] = useState("");
  const [itemCategorySaving, setItemCategorySaving] = useState(false);
  const [itemCategoriesLoading, setItemCategoriesLoading] = useState(false);
  const [itemCategoryDeletingId, setItemCategoryDeletingId] = useState("");
  const [itemSaving, setItemSaving] = useState(false);
  const [itemsLoading, setItemsLoading] = useState(false);
  const [itemDeletingId, setItemDeletingId] = useState("");
  const [itemImageUploading, setItemImageUploading] = useState(false);
  const [itemCategoryMappingSaving, setItemCategoryMappingSaving] =
    useState(false);
  const [itemCategoryMappingsLoading, setItemCategoryMappingsLoading] =
    useState(false);
  const [itemCategoryMappingDeletingKey, setItemCategoryMappingDeletingKey] =
    useState("");
  const [itemVariantSaving, setItemVariantSaving] = useState(false);
  const [itemVariantsLoading, setItemVariantsLoading] = useState(false);
  const [itemVariantDeletingId, setItemVariantDeletingId] = useState("");
  const [itemVariantPriceSaving, setItemVariantPriceSaving] = useState(false);
  const [itemVariantPricesLoading, setItemVariantPricesLoading] =
    useState(false);
  const [itemVariantPriceDeletingId, setItemVariantPriceDeletingId] =
    useState("");
  const [itemPriceTierSaving, setItemPriceTierSaving] = useState(false);
  const [itemPriceTiersLoading, setItemPriceTiersLoading] = useState(false);
  const [itemPriceTierDeletingId, setItemPriceTierDeletingId] = useState("");
  const [bulkMenuSaving, setBulkMenuSaving] = useState(false);
  const [bulkMenusLoading, setBulkMenusLoading] = useState(false);
  const [bulkMenuDeletingId, setBulkMenuDeletingId] = useState("");
  const [bulkMenuPackageMappingSaving, setBulkMenuPackageMappingSaving] =
    useState(false);
  const [bulkMenuPackageMappingsLoading, setBulkMenuPackageMappingsLoading] =
    useState(false);
  const [
    bulkMenuPackageMappingDeletingKey,
    setBulkMenuPackageMappingDeletingKey,
  ] = useState("");
  const isSuccess = (data) => !data?.responseCode || data.responseCode === "00";
  const getRestaurants = async (restaurantId = "") => {
    try {
      setRestaurantsLoading(true);
      const res = await api.post("/BulkCatalogue/restaurantsGet", {
        restaurant_id: await resolveBulkCatalogId(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to fetch restaurants",
        );
        return [];
      }
      const data = res?.data?.response;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (err) {
      console.error(
        "Bulk catalogue restaurants get error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error fetching restaurants",
      );
      return [];
    } finally {
      setRestaurantsLoading(false);
    }
  };
  const insertRestaurant = async (restaurant = {}) => {
    if (restaurantSaving) return false;
    const payload = {
      restaurant_name: String(restaurant?.restaurant_name ?? "").trim(),
      phone: String(restaurant?.phone ?? "").trim(),
      status: String(restaurant?.status ?? "ACTIVE").trim(),
    };
    if (!payload.restaurant_name)
      return (toast.error("Restaurant name is required"), false);
    if (!payload.phone) return (toast.error("Phone is required"), false);
    try {
      setRestaurantSaving(true);
      const res = await api.post("/BulkCatalogue/restaurantsInsert", payload);
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to add restaurant");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Restaurant added successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Bulk catalogue restaurant insert error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error adding restaurant",
      );
      return false;
    } finally {
      setRestaurantSaving(false);
    }
  };
  const updateRestaurant = async (restaurant = {}) => {
    if (restaurantSaving) return false;
    const payload = {
      restaurant_id: String(restaurant?.restaurant_id ?? "").trim(),
      restaurant_name: String(restaurant?.restaurant_name ?? "").trim(),
      phone: String(restaurant?.phone ?? "").trim(),
      status: String(restaurant?.status ?? "ACTIVE").trim(),
    };
    if (!payload.restaurant_id)
      return (toast.error("Restaurant ID is required"), false);
    if (!payload.restaurant_name)
      return (toast.error("Restaurant name is required"), false);
    if (!payload.phone) return (toast.error("Phone is required"), false);
    try {
      setRestaurantSaving(true);
      const res = await api.post("/BulkCatalogue/restaurantsUpdate", payload);
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to update restaurant",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Restaurant updated successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Bulk catalogue restaurant update error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error updating restaurant",
      );
      return false;
    } finally {
      setRestaurantSaving(false);
    }
  };
  const deleteRestaurant = async (restaurantId) => {
    const id = String(restaurantId ?? "").trim();
    if (!id || restaurantDeletingId) return false;
    try {
      setRestaurantDeletingId(id);
      const res = await api.post("/BulkCatalogue/restaurantsDelete", {
        restaurant_id: id,
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to delete restaurant",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Restaurant deleted successfully",
      );
      return true;
    } catch (err) {
      console.error(
        "Bulk catalogue restaurant delete error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error deleting restaurant",
      );
      return false;
    } finally {
      setRestaurantDeletingId("");
    }
  };
  const getCatalogues = async (catalogueId = "") => {
    try {
      setCataloguesLoading(true);
      const res = await api.post("/BulkCatalogue/cataloguesGet", {
        // catalog_id: await resolveBulkCatalogId(),
        restaurant_id: await resolveBulkCatalogId(),
        catalogue_id:
          String(catalogueId ?? "").trim() || (await resolveBulkCatalogId()),
      });
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to fetch catalogues");
        return [];
      }
      const data = res?.data?.response;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (err) {
      console.error(
        "Bulk catalogue catalogues get error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error fetching catalogues",
      );
      return [];
    } finally {
      setCataloguesLoading(false);
    }
  };
  const buildCataloguePayload = (catalogue = {}, includeId = false) => ({
    ...(includeId
      ? { catalogue_id: String(catalogue?.catalogue_id ?? "").trim() }
      : {}),
    restaurant_id: String(catalogue?.restaurant_id ?? "").trim(),
    catalogue_name: String(catalogue?.catalogue_name ?? "").trim(),
    description: String(catalogue?.description ?? "").trim(),
    valid_from: String(catalogue?.valid_from ?? "").trim(),
    valid_to: String(catalogue?.valid_to ?? "").trim(),
    status: String(catalogue?.status ?? "ACTIVE").trim(),
  });
  const validateCatalogue = (payload, requireId = false) => {
    if (requireId && !payload.catalogue_id)
      return (toast.error("Catalogue ID is required"), false);
    if (!payload.restaurant_id)
      return (toast.error("Restaurant is required"), false);
    if (!payload.catalogue_name)
      return (toast.error("Catalogue name is required"), false);
    return true;
  };
  const insertCatalogue = async (catalogue = {}) => {
    if (catalogueSaving) return false;
    const payload = buildCataloguePayload(catalogue);
    if (!validateCatalogue(payload)) return false;
    try {
      setCatalogueSaving(true);
      const res = await api.post("/BulkCatalogue/cataloguesInsert", payload);
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to add catalogue");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Catalogue added successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error("Bulk catalogue insert error:", err?.response?.data || err);
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error adding catalogue",
      );
      return false;
    } finally {
      setCatalogueSaving(false);
    }
  };
  const updateCatalogue = async (catalogue = {}) => {
    if (catalogueSaving) return false;
    const payload = buildCataloguePayload(catalogue, true);
    if (!validateCatalogue(payload, true)) return false;
    try {
      setCatalogueSaving(true);
      const res = await api.post("/BulkCatalogue/cataloguesUpdate", payload);
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to update catalogue");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Catalogue updated successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error("Bulk catalogue update error:", err?.response?.data || err);
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error updating catalogue",
      );
      return false;
    } finally {
      setCatalogueSaving(false);
    }
  };
  const deleteCatalogue = async (catalogueId) => {
    const id = String(catalogueId ?? "").trim();
    if (!id || catalogueDeletingId) return false;
    try {
      setCatalogueDeletingId(id);
      const res = await api.post("/BulkCatalogue/cataloguesDelete", {
        catalogue_id: id,
      });
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to delete catalogue");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Catalogue deleted successfully",
      );
      return true;
    } catch (err) {
      console.error("Bulk catalogue delete error:", err?.response?.data || err);
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error deleting catalogue",
      );
      return false;
    } finally {
      setCatalogueDeletingId("");
    }
  };
  const getItemCategories = async (categoryId = "") => {
    try {
      setItemCategoriesLoading(true);
      const res = await api.post("/BulkCatalogue/itemCategoriesGet", {
        catalogue_id: await resolveBulkCatalogId(),
        restaurant_id: await resolveBulkCatalogId(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to fetch item categories",
        );
        return [];
      }
      const data = res?.data?.response;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (err) {
      console.error(
        "Bulk catalogue item categories get error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error fetching item categories",
      );
      return [];
    } finally {
      setItemCategoriesLoading(false);
    }
  };

const buildItemCategoryPayload = (category = {}, includeId = false) => ({
  ...(includeId
    ? { category_id: String(category?.category_id ?? "").trim() }
    : {}),

  restaurant_id: String(category?.restaurant_id ?? "").trim(),

  // Send null for root categories, otherwise the selected integer ID
  parent_category_id: String(category?.parent_category_id ?? "").trim()
    ? Number(category.parent_category_id)
    : null,

  category_name: String(category?.category_name ?? "").trim(),

  description: String(category?.description ?? "").trim(),

  display_order: String(category?.display_order ?? "").trim(),

  status: String(category?.status ?? "ACTIVE").trim(),
});

  const validateItemCategory = (payload, requireId = false) => {
    if (requireId && !payload.category_id)
      return (toast.error("Category ID is required"), false);
    if (!payload.restaurant_id)
      return (toast.error("Restaurant is required"), false);
    if (!payload.category_name)
      return (toast.error("Category name is required"), false);
    return true;
  };
  const insertItemCategory = async (category = {}) => {
    if (itemCategorySaving) return false;
    const payload = buildItemCategoryPayload(category);
    if (!validateItemCategory(payload)) return false;
    try {
      setItemCategorySaving(true);
      const res = await api.post(
        "/BulkCatalogue/itemCategoriesInsert",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to add item category",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item category added successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Bulk catalogue item category insert error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error adding item category",
      );
      return false;
    } finally {
      setItemCategorySaving(false);
    }
  };
  const updateItemCategory = async (category = {}) => {
    if (itemCategorySaving) return false;
    const payload = buildItemCategoryPayload(category, true);
    if (!validateItemCategory(payload, true)) return false;
    try {
      setItemCategorySaving(true);
      const res = await api.post(
        "/BulkCatalogue/itemCategoriesUpdate",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to update item category",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item category updated successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Bulk catalogue item category update error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error updating item category",
      );
      return false;
    } finally {
      setItemCategorySaving(false);
    }
  };
  const deleteItemCategory = async (categoryId) => {
    const id = String(categoryId ?? "").trim();
    if (!id || itemCategoryDeletingId) return false;
    try {
      setItemCategoryDeletingId(id);
      const res = await api.post("/BulkCatalogue/itemCategoriesDelete", {
        category_id: id,
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to delete item category",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item category deleted successfully",
      );
      return true;
    } catch (err) {
      console.error(
        "Bulk catalogue item category delete error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error deleting item category",
      );
      return false;
    } finally {
      setItemCategoryDeletingId("");
    }
  };
  const getItems = async (itemId = "", restaurantId = "") => {
    try {
      setItemsLoading(true);
      const res = await api.post("/BulkCatalogue/itemsGet", {
        item_id: String(itemId ?? "").trim(),
        restaurant_id: await resolveBulkCatalogId(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to fetch items");
        return [];
      }
      const data = res?.data?.response;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (err) {
      console.error(
        "Bulk catalogue items get error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error fetching items",
      );
      return [];
    } finally {
      setItemsLoading(false);
    }
  };
  // Same PHP image-upload flow already used in useCuisine:
  // selected image -> base64 -> /v1/uploadItemImagev2.php -> image_url -> items payload.
  const uploadBulkItemImage = async ({ item_name, image_data }) => {
    if (!image_data) return "";
    if (!anlookApi) {
      toast.error("Anlook API instance missing");
      return "";
    }
    try {
      setItemImageUploading(true);
      const res = await anlookApi.post("/v1/uploadItemImagev2.php", {
        userid: String(userID || "A1437"),
        item_name: String(item_name || `bulk_item\\_${Date.now()}`),
        type: "IMG",
        image_data: String(image_data),
      });
      if (String(res?.data?.status) === "0" && res?.data?.image_url) {
        return String(res.data.image_url).trim();
      }
      toast.error(
        res?.data?.message ||
          res?.data?.responseMessage ||
          "Image upload failed",
      );
      return "";
    } catch (err) {
      console.error(
        "Bulk item image upload error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.responseMessage ||
          err?.message ||
          "Image upload failed",
      );
      return "";
    } finally {
      setItemImageUploading(false);
    }
  };
  const buildItemPayload = (item = {}, includeId = false) => ({
    ...(includeId ? { item_id: String(item?.item_id ?? "").trim() } : {}),
    restaurant_id: String(item?.restaurant_id ?? "").trim(),
    item_name: String(item?.item_name ?? "").trim(),
    item_description: String(item?.item_description ?? "").trim(),
    item_type: String(item?.item_type ?? "").trim(),
    image_url: String(item?.image_url ?? "").trim(),
    tax_percentage: String(item?.tax_percentage ?? "").trim(),
    addon_price: String(item?.addon_price ?? "").trim(),
    less_price: String(item?.less_price ?? "").trim(),
    upgrade_price: String(item?.upgrade_price ?? "").trim(),
    preparation_time_minutes: String(
      item?.preparation_time_minutes ?? "",
    ).trim(),
    status: String(item?.status ?? "ACTIVE").trim(),
  });
  const validateItem = (payload, requireId = false) => {
    if (requireId && !payload.item_id)
      return (toast.error("Item ID is required"), false);
    if (!payload.restaurant_id)
      return (toast.error("Restaurant is required"), false);
    if (!payload.item_name)
      return (toast.error("Item name is required"), false);
    return true;
  };
  const prepareItemPayload = async (item = {}, includeId = false) => {
    const payload = buildItemPayload(item, includeId);
    if (!validateItem(payload, includeId)) return null;
    if (item?.image_data) {
      const uploadedUrl = await uploadBulkItemImage({
        item_name: payload.item_name,
        image_data: item.image_data,
      });
      if (!uploadedUrl) return null;
      payload.image_url = uploadedUrl;
    }
    return payload;
  };
  const insertItem = async (item = {}) => {
    if (itemSaving) return false;
    try {
      setItemSaving(true);
      const payload = await prepareItemPayload(item, false);
      if (!payload) return false;
      const res = await api.post("/BulkCatalogue/itemsInsert", payload);
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to add item");
        return false;
      }
      toast.success(res?.data?.responseMessage || "Item added successfully");
      return res?.data || true;
    } catch (err) {
      console.error(
        "Bulk catalogue item insert error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error adding item",
      );
      return false;
    } finally {
      setItemSaving(false);
    }
  };
  const updateItem = async (item = {}) => {
    if (itemSaving) return false;
    try {
      setItemSaving(true);
      const payload = await prepareItemPayload(item, true);
      if (!payload) return false;
      const res = await api.post("/BulkCatalogue/itemsUpdate", payload);
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to update item");
        return false;
      }
      toast.success(res?.data?.responseMessage || "Item updated successfully");
      return res?.data || true;
    } catch (err) {
      console.error(
        "Bulk catalogue item update error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error updating item",
      );
      return false;
    } finally {
      setItemSaving(false);
    }
  };
  const deleteItem = async (itemId) => {
    const id = String(itemId ?? "").trim();
    if (!id || itemDeletingId) return false;
    try {
      setItemDeletingId(id);
      const res = await api.post("/BulkCatalogue/itemsDelete", { item_id: id });
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to delete item");
        return false;
      }
      toast.success(res?.data?.responseMessage || "Item deleted successfully");
      return true;
    } catch (err) {
      console.error(
        "Bulk catalogue item delete error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error deleting item",
      );
      return false;
    } finally {
      setItemDeletingId("");
    }
  };
  // =====================================================
  // ITEM <-> CATEGORY MAPPING CRUD
  // =====================================================
  const getItemCategoryMappings = async (itemId = "", categoryId = "") => {
    try {
      setItemCategoryMappingsLoading(true);
      const res = await api.post("/BulkCatalogue/itemCategoryMappingGet", {
        item_id: String(itemId ?? "").trim(),
        category_id: String(categoryId ?? "").trim(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage ||
            "Failed to fetch item category mappings",
        );
        return [];
      }
      const data = res?.data?.response;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (err) {
      console.error(
        "Item category mapping get error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error fetching item category mappings",
      );
      return [];
    } finally {
      setItemCategoryMappingsLoading(false);
    }
  };
  const buildItemCategoryMappingPayload = (mapping = {}) => ({
    item_id: String(mapping?.item_id ?? "").trim(),
    category_id: String(mapping?.category_id ?? "").trim(),
    is_primary: String(mapping?.is_primary ?? "N").trim(),
  });
  const validateItemCategoryMapping = (payload) => {
    if (!payload.item_id) return (toast.error("Item is required"), false);
    if (!payload.category_id)
      return (toast.error("Category is required"), false);
    return true;
  };
  const insertItemCategoryMapping = async (mapping = {}) => {
    if (itemCategoryMappingSaving) return false;
    const payload = buildItemCategoryMappingPayload(mapping);
    if (!validateItemCategoryMapping(payload)) return false;
    try {
      setItemCategoryMappingSaving(true);
      const res = await api.post(
        "/BulkCatalogue/itemCategoryMappingInsert",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to add item category mapping",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage ||
          "Item category mapping added successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Item category mapping insert error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error adding item category mapping",
      );
      return false;
    } finally {
      setItemCategoryMappingSaving(false);
    }
  };
  const updateItemCategoryMapping = async (mapping = {}) => {
    if (itemCategoryMappingSaving) return false;
    const payload = buildItemCategoryMappingPayload(mapping);
    if (!validateItemCategoryMapping(payload)) return false;
    try {
      setItemCategoryMappingSaving(true);
      const res = await api.post(
        "/BulkCatalogue/itemCategoryMappingUpdate",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage ||
            "Failed to update item category mapping",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage ||
          "Item category mapping updated successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Item category mapping update error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error updating item category mapping",
      );
      return false;
    } finally {
      setItemCategoryMappingSaving(false);
    }
  };
  const deleteItemCategoryMapping = async (itemId, categoryId) => {
    const payload = {
      item_id: String(itemId ?? "").trim(),
      category_id: String(categoryId ?? "").trim(),
    };
    if (
      !payload.item_id ||
      !payload.category_id ||
      itemCategoryMappingDeletingKey
    )
      return false;
    const key = `${payload.item_id}-${payload.category_id}`;
    try {
      setItemCategoryMappingDeletingKey(key);
      const res = await api.post(
        "/BulkCatalogue/itemCategoryMappingDelete",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage ||
            "Failed to delete item category mapping",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage ||
          "Item category mapping deleted successfully",
      );
      return true;
    } catch (err) {
      console.error(
        "Item category mapping delete error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error deleting item category mapping",
      );
      return false;
    } finally {
      setItemCategoryMappingDeletingKey("");
    }
  };
  const buildItemVariantPayload = (variant = {}, includeId = false) => ({
    ...(includeId
      ? { variant_id: String(variant?.variant_id ?? "").trim() }
      : {}),
    item_id: String(variant?.item_id ?? "").trim(),
    variant_name: String(variant?.variant_name ?? "").trim(),
    unit_type: String(variant?.unit_type ?? "").trim(),
    unit_value: String(variant?.unit_value ?? "").trim(),
    serves_people: String(variant?.serves_people ?? "").trim(),
    sku: String(variant?.sku ?? "").trim(),
    status: String(variant?.status ?? "ACTIVE").trim(),
   fk_package_id:
  variant?.fk_package_id == null ||
  String(variant.fk_package_id).trim() === ""
    ? null
    : Number(variant.fk_package_id),
  });
  
  const getItemVariants = async (itemId = "") => {
    try {
      setItemVariantsLoading(true);
      const res = await api.post("/BulkCatalogue/itemVariantsGet", {
        item_id: String(itemId ?? "").trim(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to fetch item variants",
        );
        return [];
      }
      const data = res?.data?.response;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (err) {
      console.error("Item variants get error:", err?.response?.data || err);
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error fetching item variants",
      );
      return [];
    } finally {
      setItemVariantsLoading(false);
    }
  };
  const validateItemVariant = (payload, includeId = false) => {
    if (includeId && !payload.variant_id)
      return (toast.error("Variant ID is required"), false);
    if (!payload.item_id) return (toast.error("Item is required"), false);
    if (!payload.variant_name)
      return (toast.error("Variant name is required"), false);
    return true;
  };
  const insertItemVariant = async (variant = {}) => {
    if (itemVariantSaving) return false;
    const payload = buildItemVariantPayload(variant);
    if (!validateItemVariant(payload)) return false;
    try {
      setItemVariantSaving(true);
      const res = await api.post("/BulkCatalogue/itemVariantsInsert", payload);
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to add item variant");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item variant added successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error("Item variant insert error:", err?.response?.data || err);
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error adding item variant",
      );
      return false;
    } finally {
      setItemVariantSaving(false);
    }
  };
  const updateItemVariant = async (variant = {}) => {
    if (itemVariantSaving) return false;
    const payload = buildItemVariantPayload(variant, true);
    if (!validateItemVariant(payload, true)) return false;
    try {
      setItemVariantSaving(true);
      const res = await api.post("/BulkCatalogue/itemVariantsUpdate", payload);
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to update item variant",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item variant updated successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error("Item variant update error:", err?.response?.data || err);
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error updating item variant",
      );
      return false;
    } finally {
      setItemVariantSaving(false);
    }
  };
  const deleteItemVariant = async (variantId) => {
    const id = String(variantId ?? "").trim();
    if (!id || itemVariantDeletingId) return false;
    try {
      setItemVariantDeletingId(id);
      const res = await api.post("/BulkCatalogue/itemVariantsDelete", {
        variant_id: id,
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to delete item variant",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item variant deleted successfully",
      );
      return true;
    } catch (err) {
      console.error("Item variant delete error:", err?.response?.data || err);
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error deleting item variant",
      );
      return false;
    } finally {
      setItemVariantDeletingId("");
    }
  };
  const buildItemVariantPricePayload = (row = {}, includeId = false) => ({
    ...(includeId
      ? { variant_price_id: String(row?.variant_price_id ?? "").trim() }
      : {}),
    catalogue_id: String(row?.catalogue_id ?? "").trim(),
    variant_id: String(row?.variant_id ?? "").trim(),
    order_type: String(row?.order_type ?? "").trim(),
    price: String(row?.price ?? "").trim(),
    has_minimum_order: String(row?.has_minimum_order ?? "").trim(),
    minimum_quantity: String(row?.minimum_quantity ?? "").trim(),
    minimum_order_unit: String(row?.minimum_order_unit ?? "").trim(),
    maximum_quantity: String(row?.maximum_quantity ?? "").trim(),
    quantity_step: String(row?.quantity_step ?? "").trim(),
    valid_from: String(row?.valid_from ?? "").trim(),
    valid_to: String(row?.valid_to ?? "").trim(),
    status: String(row?.status ?? "ACTIVE").trim(),
  });
  const getItemVariantPrices = async (variantId = "") => {
    try {
      setItemVariantPricesLoading(true);
      const res = await api.post("/BulkCatalogue/itemVariantPricesGet", {
        variant_id: String(variantId ?? "").trim(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to fetch item variant prices",
        );
        return [];
      }
      const data = res?.data?.response;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (err) {
      console.error(
        "Item variant prices get error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error fetching item variant prices",
      );
      return [];
    } finally {
      setItemVariantPricesLoading(false);
    }
  };
  const validateItemVariantPrice = (payload, includeId = false) => {
    if (includeId && !payload.variant_price_id)
      return (toast.error("Variant Price ID is required"), false);
    if (!payload.catalogue_id)
      return (toast.error("Catalogue is required"), false);
    if (!payload.variant_id) return (toast.error("Variant is required"), false);
    return true;
  };
  const insertItemVariantPrice = async (row = {}) => {
    if (itemVariantPriceSaving) return false;
    const payload = buildItemVariantPricePayload(row);
    if (!validateItemVariantPrice(payload)) return false;
    try {
      setItemVariantPriceSaving(true);
      const res = await api.post(
        "/BulkCatalogue/itemVariantPricesInsert",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to add item variant price",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item variant price added successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Item variant price insert error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error adding item variant price",
      );
      return false;
    } finally {
      setItemVariantPriceSaving(false);
    }
  };
  const updateItemVariantPrice = async (row = {}) => {
    if (itemVariantPriceSaving) return false;
    const payload = buildItemVariantPricePayload(row, true);
    if (!validateItemVariantPrice(payload, true)) return false;
    try {
      setItemVariantPriceSaving(true);
      const res = await api.post(
        "/BulkCatalogue/itemVariantPricesUpdate",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to update item variant price",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item variant price updated successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Item variant price update error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error updating item variant price",
      );
      return false;
    } finally {
      setItemVariantPriceSaving(false);
    }
  };
  const deleteItemVariantPrice = async (variantPriceId) => {
    const id = String(variantPriceId ?? "").trim();
    if (!id || itemVariantPriceDeletingId) return false;
    try {
      setItemVariantPriceDeletingId(id);
      const res = await api.post("/BulkCatalogue/itemVariantPricesDelete", {
        variant_price_id: id,
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to delete item variant price",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item variant price deleted successfully",
      );
      return true;
    } catch (err) {
      console.error(
        "Item variant price delete error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error deleting item variant price",
      );
      return false;
    } finally {
      setItemVariantPriceDeletingId("");
    }
  };
  const buildItemPriceTierPayload = (row = {}, includeId = false) => ({
    ...(includeId
      ? { item_price_tier_id: String(row?.item_price_tier_id ?? "").trim() }
      : {}),
    variant_price_id: String(row?.variant_price_id ?? "").trim(),
    minimum_quantity: String(row?.minimum_quantity ?? "").trim(),
    maximum_quantity: String(row?.maximum_quantity ?? "").trim(),
    price_type: String(row?.price_type ?? "").trim(),
    price: String(row?.price ?? "").trim(),
  });
  const getItemPriceTiers = async (variantPriceId = "") => {
    try {
      setItemPriceTiersLoading(true);
      const res = await api.post("/BulkCatalogue/itemPriceTiersGet", {
        variant_price_id: String(variantPriceId ?? "").trim(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to fetch item price tiers",
        );
        return [];
      }
      const data = res?.data?.response;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (err) {
      console.error("Item price tiers get error:", err?.response?.data || err);
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error fetching item price tiers",
      );
      return [];
    } finally {
      setItemPriceTiersLoading(false);
    }
  };
  const validateItemPriceTier = (payload, includeId = false) => {
    if (includeId && !payload.item_price_tier_id) {
      toast.error("Item Price Tier ID is required");
      return false;
    }
    if (!payload.variant_price_id) {
      toast.error("Variant Price is required");
      return false;
    }
    return true;
  };
  const insertItemPriceTier = async (row = {}) => {
    if (itemPriceTierSaving) return false;
    const payload = buildItemPriceTierPayload(row);
    if (!validateItemPriceTier(payload)) return false;
    try {
      setItemPriceTierSaving(true);
      const res = await api.post(
        "/BulkCatalogue/itemPriceTiersInsert",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to add item price tier",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item price tier added successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Item price tier insert error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error adding item price tier",
      );
      return false;
    } finally {
      setItemPriceTierSaving(false);
    }
  };
  const updateItemPriceTier = async (row = {}) => {
    if (itemPriceTierSaving) return false;
    const payload = buildItemPriceTierPayload(row, true);
    if (!validateItemPriceTier(payload, true)) return false;
    try {
      setItemPriceTierSaving(true);
      const res = await api.post(
        "/BulkCatalogue/itemPriceTiersUpdate",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to update item price tier",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item price tier updated successfully",
      );
      return res?.data || true;
    } catch (err) {
      console.error(
        "Item price tier update error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error updating item price tier",
      );
      return false;
    } finally {
      setItemPriceTierSaving(false);
    }
  };
  const deleteItemPriceTier = async (itemPriceTierId) => {
    const id = String(itemPriceTierId ?? "").trim();
    if (!id || itemPriceTierDeletingId) return false;
    try {
      setItemPriceTierDeletingId(id);
      const res = await api.post("/BulkCatalogue/itemPriceTiersDelete", {
        item_price_tier_id: id,
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to delete item price tier",
        );
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Item price tier deleted successfully",
      );
      return true;
    } catch (err) {
      console.error(
        "Item price tier delete error:",
        err?.response?.data || err,
      );
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Error deleting item price tier",
      );
      return false;
    } finally {
      setItemPriceTierDeletingId("");
    }
  };
  const getBulkMenus = async (id = "") => {
    try {
      setBulkMenusLoading(true);
      const res = await api.post("/BulkCatalogue/bulkMenuGet", {
        id: String(id ?? "").trim(),
        catalog_id: await resolveBulkCatalogId(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to fetch bulk menus");
        return [];
      }
      const data = res?.data?.response;
      return Array.isArray(data)
        ? data
        : data && typeof data === "object"
          ? [data]
          : [];
    } catch (err) {
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.message ||
          "Error fetching bulk menus",
      );
      return [];
    } finally {
      setBulkMenusLoading(false);
    }
  };
  const bulkMenuPayload = (row = {}, withId = false) => ({
    ...(withId ? { id: String(row?.id ?? "").trim() } : {}),
    menu_name: String(row?.menu_name ?? "").trim(),
    menu_icon: String(row?.menu_icon ?? "").trim(),
    menu_sequence: String(row?.menu_sequence ?? "").trim(),
    is_active: String(row?.is_active ?? "Y").trim(),
    catalog_id: String(row?.catalog_id ?? "").trim(),
  });
  const insertBulkMenu = async (row = {}) => {
    if (bulkMenuSaving) return false;
    const payload = bulkMenuPayload(row);
    if (!payload.menu_name)
      return (toast.error("Menu name is required"), false);
    try {
      setBulkMenuSaving(true);
      const catalogId = await resolveBulkCatalogId();
      if (!catalogId) {
        toast.error("Catalog ID not found for the current restaurant");
        return false;
      }
      payload.catalog_id = catalogId;
      const res = await api.post("/BulkCatalogue/bulkMenuInsert", payload);
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to add bulk menu");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Bulk menu added successfully",
      );
      return true;
    } catch (err) {
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.message ||
          "Error adding bulk menu",
      );
      return false;
    } finally {
      setBulkMenuSaving(false);
    }
  };
  const updateBulkMenu = async (row = {}) => {
    if (bulkMenuSaving) return false;
    const payload = bulkMenuPayload(row, true);
    if (!payload.id) return (toast.error("Menu ID is required"), false);
    try {
      setBulkMenuSaving(true);
      const catalogId = await resolveBulkCatalogId();
      if (!catalogId) {
        toast.error("Catalog ID not found for the current restaurant");
        return false;
      }
      payload.catalog_id = catalogId;
      const res = await api.post("/BulkCatalogue/bulkMenuUpdate", payload);
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to update bulk menu");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Bulk menu updated successfully",
      );
      return true;
    } catch (err) {
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.message ||
          "Error updating bulk menu",
      );
      return false;
    } finally {
      setBulkMenuSaving(false);
    }
  };
  const deleteBulkMenu = async (id) => {
    id = String(id ?? "").trim();
    if (!id || bulkMenuDeletingId) return false;
    try {
      setBulkMenuDeletingId(id);
      const res = await api.post("/BulkCatalogue/bulkMenuDelete", { id });
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to delete bulk menu");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Bulk menu deleted successfully",
      );
      return true;
    } catch (err) {
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.message ||
          "Error deleting bulk menu",
      );
      return false;
    } finally {
      setBulkMenuDeletingId("");
    }
  };
  const getBulkMenuPackageMappings = async (menuId = "", packageId = "") => {
    try {
      setBulkMenuPackageMappingsLoading(true);
      const res = await api.post("/BulkCatalogue/bulkMenuPackageMappingGet", {
        menu_id: String(menuId ?? "").trim(),
        package_id: String(packageId ?? "").trim(),
        catalog_id: await resolveBulkCatalogId(),
      });
      if (!isSuccess(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to fetch menu package mappings",
        );
        return [];
      }
      const data = res?.data?.response;
      return Array.isArray(data)
        ? data
        : data && typeof data === "object"
          ? [data]
          : [];
    } catch (err) {
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.message ||
          "Error fetching menu package mappings",
      );
      return [];
    } finally {
      setBulkMenuPackageMappingsLoading(false);
    }
  };
  const mappingPayload = (row = {}) => ({
    menu_id: String(row?.menu_id ?? "").trim(),
    package_id: String(row?.package_id ?? "").trim(),
    display_order: String(row?.display_order ?? "").trim(),
    is_primary: ["1", "Y", "TRUE"].includes(
      String(row?.is_primary ?? "0")
        .trim()
        .toUpperCase(),
    )
      ? "1"
      : "0",
  });
  const insertBulkMenuPackageMapping = async (row = {}) => {
    if (bulkMenuPackageMappingSaving) return false;
    const payload = mappingPayload(row);
    if (!payload.menu_id || !payload.package_id)
      return (toast.error("Menu and Package are required"), false);
    try {
      setBulkMenuPackageMappingSaving(true);
      const res = await api.post(
        "/BulkCatalogue/bulkMenuPackageMappingInsert",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to add mapping");
        return false;
      }
      toast.success(res?.data?.responseMessage || "Mapping added successfully");
      return true;
    } catch (err) {
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.message ||
          "Error adding mapping",
      );
      return false;
    } finally {
      setBulkMenuPackageMappingSaving(false);
    }
  };
  const updateBulkMenuPackageMapping = async (row = {}) => {
    if (bulkMenuPackageMappingSaving) return false;
    const payload = mappingPayload(row);
    try {
      setBulkMenuPackageMappingSaving(true);
      const res = await api.post(
        "/BulkCatalogue/bulkMenuPackageMappingUpdate",
        payload,
      );
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to update mapping");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Mapping updated successfully",
      );
      return true;
    } catch (err) {
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.message ||
          "Error updating mapping",
      );
      return false;
    } finally {
      setBulkMenuPackageMappingSaving(false);
    }
  };
  const deleteBulkMenuPackageMapping = async (menuId, packageId) => {
    const key = `${menuId}:${packageId}`;
    if (bulkMenuPackageMappingDeletingKey) return false;
    try {
      setBulkMenuPackageMappingDeletingKey(key);
      const res = await api.post(
        "/BulkCatalogue/bulkMenuPackageMappingDelete",
        {
          menu_id: String(menuId ?? "").trim(),
          package_id: String(packageId ?? "").trim(),
        },
      );
      if (!isSuccess(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to delete mapping");
        return false;
      }
      toast.success(
        res?.data?.responseMessage || "Mapping deleted successfully",
      );
      return true;
    } catch (err) {
      toast.error(
        err?.response?.data?.responseMessage ||
          err?.message ||
          "Error deleting mapping",
      );
      return false;
    } finally {
      setBulkMenuPackageMappingDeletingKey("");
    }
  };
  return {
    resolveBulkCatalogId,
    restaurantSaving,
    restaurantsLoading,
    restaurantDeletingId,
    getRestaurants,
    insertRestaurant,
    updateRestaurant,
    deleteRestaurant,
    catalogueSaving,
    cataloguesLoading,
    catalogueDeletingId,
    getCatalogues,
    insertCatalogue,
    updateCatalogue,
    deleteCatalogue,
    itemCategorySaving,
    itemCategoriesLoading,
    itemCategoryDeletingId,
    getItemCategories,
    insertItemCategory,
    updateItemCategory,
    deleteItemCategory,
    itemSaving,
    itemsLoading,
    itemDeletingId,
    itemImageUploading,
    getItems,
    insertItem,
    updateItem,
    deleteItem,
    uploadBulkItemImage,
    itemCategoryMappingSaving,
    itemCategoryMappingsLoading,
    itemCategoryMappingDeletingKey,
    getItemCategoryMappings,
    insertItemCategoryMapping,
    updateItemCategoryMapping,
    deleteItemCategoryMapping,
    itemVariantSaving,
    itemVariantsLoading,
    itemVariantDeletingId,
    getItemVariants,
    insertItemVariant,
    updateItemVariant,
    deleteItemVariant,
    itemVariantPriceSaving,
    itemVariantPricesLoading,
    itemVariantPriceDeletingId,
    getItemVariantPrices,
    insertItemVariantPrice,
    updateItemVariantPrice,
    deleteItemVariantPrice,
    itemPriceTierSaving,
    itemPriceTiersLoading,
    itemPriceTierDeletingId,
    getItemPriceTiers,
    insertItemPriceTier,
    updateItemPriceTier,
    deleteItemPriceTier,
    bulkMenuSaving,
    bulkMenusLoading,
    bulkMenuDeletingId,
    getBulkMenus,
    insertBulkMenu,
    updateBulkMenu,
    deleteBulkMenu,
    bulkMenuPackageMappingSaving,
    bulkMenuPackageMappingsLoading,
    bulkMenuPackageMappingDeletingKey,
    getBulkMenuPackageMappings,
    insertBulkMenuPackageMapping,
    updateBulkMenuPackageMapping,
    deleteBulkMenuPackageMapping,
  };
}
